<template>
  <div>
  <panel class="pt-6 mt-8">
  <div class="flex flex-wrap -mx-3">
    <div class="w-full md:w-1/2 lg:w-1/5 px-3 mb-6">
      <label class="uppercase text-grey-darker mb-1 block">Search</label>
      <input type="text" v-model="searchParams.q" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" />
    </div>
    <div class="w-full md:w-1/2 lg:w-1/5 px-3 mb-6">
      <label class="uppercase text-grey-darker mb-1 block">Country</label>
      <select v-model="searchParams.country" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
        <option v-for="(option, j) in countryOptions" :key="j" :value="option.id">
          {{ option.name }}
         </option>
      </select>
    </div>
    <div class="w-full md:w-1/2 lg:w-1/5 px-3 mb-6">
      <label class="uppercase text-grey-darker mb-1 block">Facebook</label>
      <select v-model="searchParams.facebook" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
        <option v-for="(option, j) in socialMediaOptions" :key="j" :value="option.id">
          {{ option.name }}
         </option>
      </select>
    </div>
    <div class="w-full md:w-1/2 lg:w-1/5 px-3 mb-6">
      <label class="uppercase text-grey-darker mb-1 block">Instagram</label>
      <select v-model="searchParams.instagram" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
        <option v-for="(option, j) in socialMediaOptions" :key="j" :value="option.id">
          {{ option.name }}
         </option>
      </select>
    </div>
    <div class="w-full md:w-1/2 lg:w-1/5 px-3 mb-6">
      <label class="uppercase text-grey-darker mb-1 block">Youtube</label>
      <select v-model="searchParams.youtube" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
        <option v-for="(option, j) in socialMediaOptions" :key="j" :value="option.id">
          {{ option.name }}
         </option>
      </select>
    </div>
  </div>
  <hr class="border-b border-grey-darker w-full mb-6" />
  <loader v-if="!officeList.data" />
  <div v-else-if="officeList.data.length === 0">
    No office found.
  </div>
  <div v-else>
    <table>
      <thead>
        <th class="text-left">Office</th>
        <th>Facebook</th>
        <th>Instgram</th>
        <th>Youtube</th>
      </thead>
      <tbody>
        <tr v-for="office in officeList.data" :key="office.id">

          <td class="text-left font-bold">
            {{ office.name }}
          </td>
          <td class="text-center">
            <div class="flex justify-center items-center" v-if="office.social_media.facebook">
              <span @click="socialMediaClick(office.id,'facebook_last_viewed_at')">
                <a :href="office.social_media.facebook" target="_blank"><i class="fab fa-facebook mr-2 fa-2x text-blue"></i></a>
              </span>
              <div class="flex items-center ml-4">
                <span>Last Viewed
                  <p class="mt-2" v-if="office.social_media_log.length > 0 && office.social_media_log[0].facebook_last_viewed_at">
                    {{ office.social_media_log[0].facebook_last_viewed_at | date }}
                  </p>
                  <p v-else>Never</p>
                </span>
              </div>
            </div>
            <div v-else class="font-bold">-</div>
          </td>
          <td class="text-center">
            <div class="flex justify-center items-center" v-if="office.social_media.instagram">
              <span @click="socialMediaClick(office.id,'instagram_last_viewed_at')">
                <a :href="office.social_media.instagram" target="_blank" style="color: inherit"><icon class="w-10 h-10" name="instagram" :center="false" /></a>
              </span>
              <div class="flex items-center ml-4">
                <span>Last Viewed
                  <p class="mt-2" v-if="office.social_media_log.length > 0 && office.social_media_log[0].instagram_last_viewed_at">
                    {{office.social_media_log[0].instagram_last_viewed_at | date}}
                  </p>
                  <p v-else>Never</p>
                </span>
              </div>
            </div>
            <div v-else class="font-bold">-</div>
          </td>
          <td class="text-center">
            <div class="flex justify-center items-center" v-if="office.social_media.youtube">
              <span @click="socialMediaClick(office.id,'youtube_last_viewed_at')">
                <a :href="office.social_media.youtube" target="_blank"><i class="fab fa-youtube mr-2 fa-2x text-red"></i></a>
              </span>
              <div class="flex items-center ml-4">
                <span>Last Viewed
                  <p class="mt-2" v-if="office.social_media_log.length > 0 && office.social_media_log[0].youtube_last_viewed_at">
                    {{office.social_media_log[0].youtube_last_viewed_at | date}}
                  </p>
                  <p v-else>Never</p>
                </span>
              </div>
            </div>
            <div v-else class="font-bold">-</div>
          </td>
        </tr>
      </tbody>
    </table>
    <paginator :data="officeList" @change="page"/>
  </div>
</panel>
</div>
</template>

<script>
import { v2Api } from '@/http'
import { mapState } from 'vuex'
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      searchParams: {
        page: 1,
        q: '',
        country: 'GB',
        facebook: '',
        instagram: '',
        youtube: ''
      },
      officeList: [],
      countryOptions: [
        { 'id': 'GB', 'name': 'UK' },
        { 'id': 'AU', 'name': 'Australia' },
        { 'id': 'BB', 'name': 'Barbados' },
        { 'id': 'FR', 'name': 'France' },
        { 'id': 'DE', 'name': 'Germany' },
        { 'id': 'HU', 'name': 'Hungary' },
        { 'id': 'IE', 'name': 'Ireland' },
        { 'id': 'JE', 'name': 'Jersey' },
        { 'id': 'MU', 'name': 'Mauritius' },
        { 'id': 'NA', 'name': 'Namibia' },
        { 'id': 'PT', 'name': 'Portugal' },
        { 'id': 'ZA', 'name': 'South Africa' },
        { 'id': 'ES', 'name': 'Spain' },
        { 'id': 'CH', 'name': 'Switzerland' },
        { 'id': 'TH', 'name': 'Thailand' },
        { 'id': 'AE', 'name': 'UAE' },
        { 'id': 'ZW', 'name': 'Zimbabwe' }
      ],
      socialMediaOptions: [
        { 'id': '', 'name': 'Both' },
        { 'id': 'viewed', 'name': 'Viewed' },
        { 'id': 'never', 'name': 'Never Viewed' }
      ]
    }
  },
  watch: {
    selectedOffice: {
      handler () {
        this.search()
      },
      deep: true
    },
    searchParams: {
      handler () {
        this.search()
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
    this.search()
  },
  methods: {
    search: debounce(function () {
      this.searchParams.viewed_from_office_id = this.selectedOffice.id
      v2Api.get('/social-media', {
        params: this.searchParams
      }).then((response) => {
        this.officeList = response.data
      })
    }, 500),
    socialMediaClick (officeId, socialMediaType) {
      var dataToSend = {
        viewed_from_office_id: this.selectedOffice.id,
        viewed_to_office_id: officeId,
        type: socialMediaType
      }
      v2Api.patch('/update-social-media-log', dataToSend).then(
        response => {
          this.search()
        }
      )
    },
    page (i) {
      this.searchParams.page = i
      this.search()
    }
  }
}
</script>

<style lang="sass" scoped>
table
  @apply table-auto w-full
  thead
    @apply border-b uppercase text-xs
    th
      @apply pb-2 font-semibold
  tbody
    @apply text-sm capitalize
    tr
      @apply border-b
      td
        @apply py-4 align-middle
.recruitment-section
  @apply mt-4 p-6 rounded-lg bg-white
.recruitment-button
  @apply mr-4 py-2 px-6 rounded
  transition: background .5s
  &--small
    @apply text-sm px-4
</style>
